<app-main-carousel [slides]="slides"></app-main-carousel>
<div class="theme-container">
<!--<div fxLayout="row wrap" class="info-bar">-->
<!--    <div fxFlex="100" fxFlex.gt-md="25" fxFlex.gt-xs="50">-->
<!--        <mat-card class="light-block" fxLayout="row"  fxLayoutAlign="start center">-->
<!--            <mat-icon class="mat-icon-xlg text-muted m-0">card_giftcard</mat-icon>-->
<!--            <div class="content">-->
<!--                <p>{{'TOBA LIGHT.label.HomePage.bonusPlus' | translate }}</p>-->
<!--                <span class="text-muted m-0">{{'TOBA LIGHT.label.HomePage.MakeFunOfShoppingAndCollectBonuses' | translate }}</span>-->
<!--            </div> -->
<!--        </mat-card> -->
<!--    </div>-->
<!--    <div fxFlex="100" fxFlex.gt-md="25" fxFlex.gt-xs="50"> -->
<!--        <mat-card class="light-block" fxLayout="row"  fxLayoutAlign="start center">-->
<!--            <mat-icon class="mat-icon-xlg text-muted m-0">local_shipping</mat-icon>-->
<!--            <div class="content">-->
<!--                <p>{{'TOBA LIGHT.label.HomePage.FreeShipphng' | translate }}</p>-->
<!--                <span class="text-muted m-0">{{'TOBA LIGHT.label.HomePage.FreeShippingOnAllOrders' | translate }}</span>-->
<!--            </div> -->
<!--        </mat-card>-->
<!--    </div>-->
<!--    <div fxFlex="100" fxFlex.gt-md="25" fxFlex.gt-xs="50"> -->
<!--        <mat-card class="light-block" fxLayout="row"  fxLayoutAlign="start center">-->
<!--            <mat-icon class="mat-icon-xlg text-muted m-0">monetization_on</mat-icon>-->
<!--            <div class="content">-->
<!--                <p>{{'TOBA LIGHT.label.HomePage.MoneyBackGuarntee' | translate }}</p>-->
<!--                <span class="text-muted m-0">{{'TOBA LIGHT.label.HomePage.DaysMoneyReturnGuarantee' | translate }}</span>-->
<!--            </div> -->
<!--        </mat-card>-->
<!--    </div>-->
<!--    <div fxFlex="100" fxFlex.gt-md="25" fxFlex.gt-xs="50"> -->
<!--        <mat-card class="light-block" fxLayout="row"  fxLayoutAlign="start center">-->
<!--            <mat-icon class="mat-icon-xlg text-muted m-0">history</mat-icon>-->
<!--            <div class="content">-->
<!--                <p>{{'TOBA LIGHT.label.HomePage.OnlineSupport' | translate }}</p>-->
<!--                <span class="text-muted m-0">{{'TOBA LIGHT.label.HomePage.CallUs' | translate }}</span>-->
<!--            </div> -->
<!--        </mat-card>-->
<!--    </div>-->
<!--</div>-->
<app-background-video></app-background-video>
<!--<app-banners [banners]="banners"></app-banners>-->
<app-category-gallery [categoriesToDisplay]="mainCategories"></app-category-gallery>

    <div class="products-tabs">

    <mat-tab-group mat-stretch-tabs (selectedTabChange)="onLinkClick($event)">
       
        <mat-tab label="מומלצים">
           <app-products-carousel [products]="featuredProducts"></app-products-carousel>
        </mat-tab>
        <mat-tab label="במבצע">
           <app-products-carousel [products]="onSaleProducts"></app-products-carousel>
        </mat-tab>
        <mat-tab label="דירוג גבוהה">
            <app-products-carousel [products]="topRatedProducts"></app-products-carousel>
        </mat-tab>
        <mat-tab label="מוצרים חדשים">
            <app-products-carousel [products]="newArrivalsProducts"></app-products-carousel>
        </mat-tab>
    </mat-tab-group> 


</div>

<app-brands-carousel [brands]="brands"></app-brands-carousel>
</div>
